import { render, staticRenderFns } from "./singleAdministrationChildrenThreeEdit.vue?vue&type=template&id=4ef5683e"
import script from "./singleAdministrationChildrenThreeEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenThreeEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenThreeEdit.vue?vue&type=style&index=0&id=4ef5683e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports